import RatgeberTemplate from "@/components/RatgeberTemplate";
import { getRatgeberBySlug } from "@/data/ratgeberData";
import Footer from "@/components/Footer";

const RatgeberAbnehmen = () => {
  const content = getRatgeberBySlug("abnehmen");
  
  if (!content) return null;

  return (
    <>
      <RatgeberTemplate content={content} />
      <Footer />
    </>
  );
};

export default RatgeberAbnehmen;
